import { Component, Input, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { ExpansionPanelData } from '@usimweb/core/models';
// import { FoamingObj } from '../../../../core/models/version.interface';

@Component({
    selector: 'app-input-parameters',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './input-parameters.component.html',
    styleUrls: ['./input-parameters.component.scss'],
    standalone: false
})
export class InputParametersComponent implements OnChanges {
  @Input() foaming: any = {} as any;

  @Input() recipe: string = '';

  public data!: ExpansionPanelData[];

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['foaming'] && this.foaming) || (changes['recipe'] && this.recipe)) {
      this.setData();
    }
  }

  private setData() {
    this.data = [
      {
        title: 'Material',
        row: [
          {
            col: [
              { value: this.foaming.materialName, placeholder: 'Material' },
              { value: this.foaming.materialTemperature, placeholder: 'Temperature [°C]' },
            ],
          },
        ],
      },
      {
        title: 'Process Data',
        row: [
          {
            col: [
              { value: this.foaming.targetDensity, placeholder: 'Target density [g/L]' },
              { value: this.foaming.mass, placeholder: 'Mass [kg]' },
              { value: this.foaming.overpackingFactor, placeholder: 'Overpacking factor' },
            ],
          },
          {
            col: [
              { value: this.foaming.injectionRate, placeholder: 'Injection rate [kg/s]' },
              { value: this.foaming.injectionTime, placeholder: 'Injection time [s]' },
            ],
          },
        ],
      },
      {
        title: 'Simulate',
        row: [
          {
            col: [
              { value: this.foaming.simulationTime, placeholder: 'Simulation time [s]' },
              { value: this.foaming.nCpus, placeholder: 'Number of cpu' },
              { value: this.foaming.outputTime, placeholder: 'Output time [s]' },
            ],
          },
        ],
      },
    ];
  }
}
